import { useEffect, useState } from "react";
import { Wifi, WifiOff } from "lucide-react";

/**
 * Live indicator pill that reflects WS connection state.
 * Listens to global WS connect/disconnect events to flip state.
 */
export const LiveIndicator = ({ compact = false, className = "" }) => {
  const [isLive, setIsLive] = useState(true);

  useEffect(() => {
    // Track connection via window WS bridge (any received event = live)
    let lastSeen = Date.now();
    const handleWs = () => {
      lastSeen = Date.now();
      setIsLive(true);
    };
    window.addEventListener("gofood:ws", handleWs);

    // Heartbeat: if no WS event in 60s, consider offline
    const heartbeat = setInterval(() => {
      if (Date.now() - lastSeen > 60000) {
        setIsLive(false);
      }
    }, 5000);

    return () => {
      window.removeEventListener("gofood:ws", handleWs);
      clearInterval(heartbeat);
    };
  }, []);

  if (compact) {
    return (
      <span
        className={`inline-flex items-center gap-1 ${className}`}
        data-testid="live-indicator-compact"
      >
        <span className="relative flex h-2 w-2">
          {isLive && (
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75"></span>
          )}
          <span
            className={`relative inline-flex rounded-full h-2 w-2 ${
              isLive ? "bg-emerald-500" : "bg-zinc-400"
            }`}
          ></span>
        </span>
        <span className={`text-[10px] uppercase tracking-wider font-semibold ${
          isLive ? "text-emerald-600" : "text-zinc-400"
        }`}>
          {isLive ? "Ao vivo" : "Offline"}
        </span>
      </span>
    );
  }

  return (
    <div
      className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold ${
        isLive
          ? "bg-emerald-50 text-emerald-700 border border-emerald-200"
          : "bg-zinc-100 text-zinc-500 border border-zinc-200"
      } ${className}`}
      data-testid="live-indicator"
    >
      <span className="relative flex h-2 w-2">
        {isLive && (
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75"></span>
        )}
        <span
          className={`relative inline-flex rounded-full h-2 w-2 ${
            isLive ? "bg-emerald-500" : "bg-zinc-400"
          }`}
        ></span>
      </span>
      {isLive ? (
        <>
          <Wifi className="w-3 h-3" />
          Ao vivo
        </>
      ) : (
        <>
          <WifiOff className="w-3 h-3" />
          Offline
        </>
      )}
    </div>
  );
};

export default LiveIndicator;
